import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
    firstItemOnly,
} from "~utils/moduleIntegrity";

import {
    type LineupContentFeatureLedeProps,
    MEDIA_PRIORITY,
} from "./LineupContentFeatureLede";

export default function integrityCheck({
    items,
}: LineupContentFeatureLedeProps): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly<CuratedItem>(items));
    messages.push(
        ...checkMediaIntegrity(
            firstItemOnly<CuratedItem>(items),
            MEDIA_PRIORITY
        )
    );

    return messages;
}
